import counterpart from "counterpart";
const DOCUMENTRECEIVEDDATE = "documentReceivedDate";
export function getMetaData(queueId) {
  let auth = JSON.parse(sessionStorage.getItem('state')).auth;
  let canAddManualTransaction=  auth.user && auth.user.parsedPermissions && auth.user.parsedPermissions.search && auth.user.parsedPermissions.queue.addManualTransaction;
  return [
    {
      queueId: '6',
      pageId: 'tran_unmatched',
      isSummaryRow: true,
      isManualTransaction: true,
      isSummaryPanel: true,
      isHorizontalPanel: true,
      isFilterPane: true,
      isToggle: true,
      searchFilterName: 'Transaction',
      dataColumns: [],
      isExportable: true,
      canManageColumns: true,
      name: 'Un-Matched Transactions',
      detailViewTitle: 'Case Details',
      returnToText: 'Return to Queue',
      defaultSort: [{
        key: 'dueDate',
        order: 1,
      },{
        key: 'disputeAmount',
        order: 0,
      }],
      actions: [
        {
          title: 'View More Details',
          key: 'DETAIL_DRAWER',
          style: {
            width: 150,
            paddingLeft: 0,
          },

        },
        {
          title: 'Open Case',
          key: 'OPEN_CASE',
          style: {
            paddingRight: 60,
            paddingLeft: 0,
            width: 150,
          },

        },

      ],


      caseSelectionConfig: {
        page: {
          reportName: 'Search for Missing Transaction',
          actionButtonText: 'Take Action',
          dateFormat: 'MM/DD/YYYY',
        },
        summaryHeader: {
          summaryColumns: [
            {
              description: 'Days Left',
              name: 'Days Left',
              displayType: 'DAYSLEFT',
              columnKey: 'daysRemaining',
            },
            {
              description: 'Case Number',
              name: 'Case Number',
              displayType: 'STRING',
              columnKey: 'caseNumber',
            },
            {
              description: 'Transaction Amount',
              name: 'Transaction Amount',
              displayType: 'CURRENCY',
              columnKey: 'transactionAmount',
            },
            {
              description: 'Card Type',
              name: 'Card Type',
              displayType: 'cardType',
              columnKey: 'cardBrandName',
            },
            {
              description: 'Reason Code',
              name: 'Reason Code',
              displayType: 'RC',
              columnKey: 'disputeReasonCode',
              descriptionKey: 'codeDescription',

            },
            {
              description: 'Due Date',
              name: 'Due Date',
              displayType: 'DUEDATE',
              columnKey: 'dueDate',
            },
          ],
        },
        summaryPanel: {
          summaryColumns: [
            {
              name: 'Case Number',
              displayType: 'STRING',
              columnKey: 'caseNumber',
              displayOrder: 1,
              defaultIsVisible: true,
            },
            {
              name: 'Account Number',
              displayType: 'ACCOUNTNUMBER',
              columnKey: 'maskedCardNumber',
              secondaryColumnKey: 'globalToken',
              displayOrder: 2,
              defaultIsVisible: true,
            },
            {
              name: 'ARN',
              displayType: 'STRING',
              columnKey: 'acquirerReferenceNumber',
              displayOrder: 3,
              defaultIsVisible: true,
            },
            {
              name: 'Transaction Amount',
              displayType: 'CURRENCY',
              columnKey: 'transactionAmount',
              displayOrder: 4,
              defaultIsVisible: true,
            },
            {
              name: 'Transaction Date',
              displayType: 'DATE',
              columnKey: 'transactionDate',
              displayOrder: 5,
              defaultIsVisible: true,
            },
            {
              name: 'Approval Code',
              displayType: 'STRING',
              columnKey: 'authCode',
              displayOrder: 6,
              defaultIsVisible: true,
            },
            {
              name: 'Merchant Number',
              displayType: 'STRING',
              columnKey: 'cardBrandMerchantNumber',
              displayOrder: 7,
              defaultIsVisible: true,
            },
            {
              name: 'Merchant Name',
              displayType: 'STRING',
              columnKey: 'merchantName',
              displayOrder: 8,
              defaultIsVisible: true,
            },
            {
              name: 'Transaction ID',
              displayType: 'STRING',
              columnKey: 'transactionId',
              displayOrder: 9,
              defaultIsVisible: true,
            },
            {
              name: 'Scheme Case Number',
              displayType: 'STRING',
              columnKey: 'cardBrandCaseNumber',
              displayOrder: 10,
              defaultIsVisible: true,
            },
            {
              name: 'Reason Code',
              displayType: 'RC',
              columnKey: 'disputeReasonCode',
              displayOrder: 12,
              defaultIsVisible: true,
              descriptionKey: 'codeDescription',
            },
            {
              name: 'POS Entry Mode',
              displayType: 'STRING',
              columnKey: 'posEntryMode',
              displayOrder: 13,
              defaultIsVisible: true,
            },
            {
              name: 'Transaction Code',
              displayType: 'STRING',
              columnKey: 'transactionCode',
              displayOrder: 14,
              defaultIsVisible: true,
            },

            {
              name: 'Merchant Category Code',
              displayType: 'STRING',
              columnKey: 'merchantCategoryCode',
              displayOrder: 16,
              defaultIsVisible: true,
            },
            {
              name: 'Merchant Country Code',
              displayType: 'STRING',
              columnKey: 'merchantCountryCode',
              displayOrder: 17,
              defaultIsVisible: false,
            },
            {
              name: 'Usage Code',
              displayType: 'STRING',
              columnKey: 'usageCode',
              displayOrder: 18,
              defaultIsVisible: false,
            },
            {
              name: 'Mail/Phone/E-Comm and Payment Indicator',
              displayType: 'STRING',
              columnKey: 'mcQuickPaymentServiceInd﻿',
              displayOrder: 19,
              defaultIsVisible: false,
            },
            {
              name: 'Dispute Condition',
              displayType: 'STRING',
              columnKey: 'disputeCondition',
              displayOrder: 20,
              defaultIsVisible: false,
            },
            {
              name: 'Authorized Amount',
              displayType: 'STRING',
              columnKey: 'authorizedAmount',
              displayOrder: 21,
              defaultIsVisible: false,
            },
            {
              name: 'Merchant City',
              displayType: 'STRING',
              columnKey: 'merchantCity',
              displayOrder: 22,
              defaultIsVisible: false,
            },
            {
              name: 'Authorization Currency Code',
              displayType: 'STRING',
              columnKey: 'authorizationCurrencyCode',
              displayOrder: 23,
              defaultIsVisible: false,
            },
            {
              name: ' VROL Financial ID',
              displayType: 'STRING',
              columnKey: 'vrolFinancialId',
              displayOrder: 24,
              defaultIsVisible: false,
            },

          ],
        },
        summaryHorizontalPanel: {
          summaryColumns: [
            {
              name: 'Transaction Amount',
              displayType: 'CURRENCY',
              columnKey: 'transactionAmount',
              displayOrder: 0,
              defaultIsVisible: true,
              isCustomRow: true,
            },
            {
              name: 'Transaction Date',
              displayType: 'DATE',
              columnKey: 'transactionDate',
              displayOrder: 1,
              defaultIsVisible: true,
              isCustomRow: true,
            },
            {
              name: 'Transaction ID',
              displayType: 'STRING',
              columnKey: 'transactionIdentifier',
              displayOrder: 2,
              defaultIsVisible: true,
              isCustomRow: true,
            },
            {
              name: 'Attach',
              displayType: 'BUTTON',
              columnKey: '',
              displayOrder: 3,
              defaultIsVisible: true,
              isCustomRow: true,
            },
            {
              name: 'Card Number',
              displayType: 'STRING',
              columnKey: 'cardNumberRk',
              secondaryColumnKey: 'globalToken',
              displayOrder: 4,
              displayType: 'ACCOUNTNUMBER',
              defaultIsVisible: true,
              isCustomRow: false,
            },
            {
              name: 'Approval Code',
              displayType: 'STRING',
              columnKey: 'authorizationCode',
              displayOrder: 5,
              defaultIsVisible: true,
              isCustomRow: false,
            },
            {
              name: 'ARN',
              displayType: 'STRING',
              columnKey: 'acqReferenceNumber',
              displayOrder: 6,
              defaultIsVisible: true,
              isCustomRow: false,
            },
            {
              name: 'Merchant Number',
              displayType: 'STRING',
              columnKey: 'merchantNumber',
              displayOrder: 7,
              defaultIsVisible: false,
              isCustomRow: false,
            },

            {
              name: 'Txn MCC',
              displayType: 'STRING',
              columnKey: 'mcc',
              displayOrder: 8,
              defaultIsVisible: false,
              isCustomRow: false,
            },
            {
              name: 'POS Entry Mode',
              displayType: 'STRING',
              columnKey: 'posEntryMode',
              displayOrder: 9,
              defaultIsVisible: false,
              isCustomRow: false,
            },
            {
              name: 'Transaction Code',
              displayType: 'STRING',
              columnKey: 'transactionCode',
              displayOrder: 10,
              defaultIsVisible: false,
              isCustomRow: false,
            },
            {
              name: 'Transaction Time',
              displayType: 'STRING',
              columnKey: 'transactionTime',
              displayOrder: 11,
              defaultIsVisible: false,
              isCustomRow: false,
            },
            {
              name: 'Foreign Domestic',
              displayType: 'STRING',
              columnKey: 'foreignDomesticInd',
              displayOrder: 12,
              defaultIsVisible: false,
              isCustomRow: false,
            },
            {
              name: 'Transaction Currency code',
              displayType: 'STRING',
              columnKey: 'currencyCode',
              displayOrder: 13,
              defaultIsVisible: false,
              isCustomRow: false,
            },
            {
              name: 'Cryptogram',
              displayType: 'STRING',
              columnKey: 'cryptogramCode',
              displayOrder: 14,
              defaultIsVisible: false,
              isCustomRow: false,
            },
            {
              name: 'Original Reference Number',
              displayType: 'STRING',
              columnKey: 'originalTransactionReferenceNumber',
              displayOrder: 15,
              defaultIsVisible: false,
              isCustomRow: false,
            },
            {
              name: 'CAT indicator',
              displayType: 'STRING',
              columnKey: 'categoryInd',
              displayOrder: 16,
              defaultIsVisible: false,
              isCustomRow: false,
            },
            {
              name: 'Cardholder ID method',
              displayType: 'STRING',
              columnKey: 'cardholderIdMethod',
              displayOrder: 17,
              defaultIsVisible: false,
              isCustomRow: false,
            },
            {
              name: 'MOTO ECP indicator',
              displayType: 'STRING',
              columnKey: 'motoEcInd',
              displayOrder: 18,
              defaultIsVisible: false,
              isCustomRow: false,
            },
            {
              name: 'UCAF indicator',
              displayType: 'STRING',
              columnKey: 'universalCardholderAuthenticationFieldInd',
              displayOrder: 19,
              defaultIsVisible: false,
              isCustomRow: false,
            },
            {
              name: 'Authorization Amount',
              displayType: 'STRING',
              columnKey: 'authorizationAmount',
              displayOrder: 20,
              defaultIsVisible: false,
              isCustomRow: false,
            },
            {
              name: 'Foreign Amount',
              displayType: 'STRING',
              columnKey: 'foreignAmount',
              displayOrder: 21,
              defaultIsVisible: false,
              isCustomRow: false,
            },
            {
              name: 'Payment Currency Alpha',
              displayType: 'STRING',
              columnKey: 'paymentCurrencyAlpha',
              displayOrder: 22,
              defaultIsVisible: false,
              isCustomRow: false,
            },

          ],
        },
        searchFilters:
          [
            {
              defaultValue: null,
              description: 'ARN',
              displayOrder: 1,
              filterValueGroupId: 0,
              isReadOnly: false,
              isVisible: true,
              name: 'ARN',
              elementLabel: 'ARN',
              reportFilterId: 'acqRefNumber',
              elementId: 'acqRefNumber',
              filterType: 'STRING',
              elementTypeName: 'STRING',
              filterValues: null,
              isPrimaryDateFilter: null,
              isRequired: false,
              validations: [],
              columnKey: 'acquirerReferenceNumber',
              elementMandatory: false,
            },
            {
              defaultValue: null,
              description: 'Account Number',
              displayOrder: 1,
              filterValueGroupId: 0,
              isReadOnly: false,
              isVisible: true,
              name: 'Account Number',
              elementLabel: 'Account Number',
              reportFilterId: 'cardNumberRk',
              elementId: 'cardNumberRk',
              filterValues: null,
              isPrimaryDateFilter: null,
              isRequired: false,
              filterType: 'CC_NUMBER',
              elementTypeName: 'CC_NUMBER',
              cardOption: {
                value: 'six-four-digits',
                text: 'First 6 / Last 4',
              },
              validations: { helperText: '(first 6 or last 4 digits)', first6Placeholder: 'First 6', cardNum: 'Account Number (first 6 or last 4 digits)', last4Placeholder: 'Last 4' },
              columnKey: 'maskedCardNumber',
              elementMandatory: false,

            },
            {
              defaultValue: null,
              description: 'Account Number',
              displayOrder: 2,
              filterValueGroupId: 0,
              isReadOnly: false,
              isVisible: true,
              name: 'Account Number',
              elementLabel: 'Account Number',
              reportFilterId: 'cardNumber',
              elementId: 'cardNumber',
              filterType: 'FULL_CC_NUMBER',
              elementTypeName: 'FULL_CC_NUMBER',
              filterValues: null,
              isPrimaryDateFilter: null,
              isRequired: false,
              validations: [],
              columnKey: 'cardNumber',
              elementMandatory: false,
            },
            {
              defaultValue: null,
              description: 'Merchant Number',
              displayOrder: 4,
              filterValueGroupId: 0,
              isReadOnly: false,
              isVisible: true,
              name: 'Merchant Number',
              elementLabel: 'Merchant Number',
              reportFilterId: 'merchantNumber',
              elementId: 'merchantNumber',
              filterType: 'STRING',
              elementTypeName: 'STRING',
              filterValues: null,
              isPrimaryDateFilter: null,
              isRequired: false,
              validations: [],
              columnKey: 'merchantNumber',
              elementMandatory: false,

            },
            {
              defaultValue: null,
              description: 'Transaction Amount',
              displayOrder: 5,
              filterValueGroupId: 0,
              isReadOnly: false,
              isVisible: true,
              name: 'Transaction Amount',
              elementLabel: 'Transaction Amount',
              reportFilterId: 'transactionAmount',
              elementId: 'transactionAmount',
              filterType: 'CURRENCY',
              elementTypeName: 'CURRENCY',
              filterValues: null,
              isPrimaryDateFilter: null,
              isRequired: false,
              validations: [],
              columnKey: 'transactionAmount',
              elementMandatory: false,

            },
            {
              defaultValue: null,
              description: 'Transaction Date',
              displayOrder: 6,
              filterValueGroupId: 0,
              isReadOnly: false,
              isVisible: true,
              name: 'Transaction Date',
              elementLabel: 'Transaction Date',
              reportFilterId: 'transactionDate',
              elementId: 'transactionDate',
              filterType: 'DATE',
              elementTypeName: 'DATE',
              filterValues: null,
              isPrimaryDateFilter: null,
              isRequired: false,
              validations: [],
              columnKey: 'transactionDate',
              elementMandatory: true,
            },
            {
              defaultValue: null,
              description: 'Transaction Code',
              displayOrder: 7,
              filterValueGroupId: 0,
              isReadOnly: false,
              isVisible: true,
              name: 'Transaction Code',
              elementLabel: 'Transaction Code',
              reportFilterId: 'transactionCode',
              elementId: 'transactionCode',
              filterType: 'STRING',
              elementTypeName: 'STRING',
              filterValues: null,
              isPrimaryDateFilter: null,
              isRequired: false,
              validations: [],
              columnKey: 'transactionCode',
              elementMandatory: false,
            },
            {
              defaultValue: null,
              description: 'Acquirer Name',
              displayOrder: 8,
              filterValueGroupId: 0,
              isReadOnly: false,
              isVisible: false,
              name: 'Acquirer Name',
              elementLabel: 'Acquirer Name',
              reportFilterId: 'acquirerCode',
              elementId: 'acquirerCode',
              filterType: 'STRING',
              elementTypeName: 'STRING',
              filterValues: null,
              isPrimaryDateFilter: null,
              isRequired: false,
              validations: [],
              columnKey: 'acquirerCode',
              elementMandatory: false,
            },
          ],
        caseSelectionActions: canAddManualTransaction?[
          {
            text: 'Add Manual Transaction',
            value: 'ADD_MANUALLY',
          },
          {
            text: 'Go To Caselanding',
            value: 'ISSUER_FORWARD',
          },
        ]:[
          {
            text: 'Go To Caselanding',
            value: 'ISSUER_FORWARD',
          },
        ],
        suggestedPanel: [],
        customComponents: [],
      },
    },
    {
      queueId: '8',
      pageId: 'merch_matched_fail',
      isSummaryRow: true,
      isManualTransaction: false,
      isSummaryPanel: true,
      isHorizontalPanel: false,
      isFilterPane: false,
      isToggle: false,
      name: 'Un-Matched Merchants',
      detailViewTitle: 'Case Details',
      returnToText: 'Return to Queue',
      isExportable: true,
      canManageColumns: true,
      defaultSort: [{
        key: 'dueDate',
        order: 1,
      },{
        key: 'disputeAmount',
        order: 0,
      }],
      dataColumns: [],

      caseSelectionActions: [
      ],
      caseSelectionConfig: {
        page: {
          reportName: 'Missing Merchant',
          actionButtonText: '',
          dateFormat: 'MM/DD/YYYY',
        },
        summaryHeader: {
          summaryColumns: [
            {
              description: 'Days Left',
              name: 'Days Left',
              displayType: 'DAYSLEFT',
              columnKey: 'daysRemaining',
            },
            {
              description: 'Case Number',
              name: 'Case Number',
              displayType: 'STRING',
              columnKey: 'caseNumber',
            },
            {
              description: 'Disputed Amount',
              name: 'Disputed Amount',
              displayType: 'CURRENCY',
              columnKey: 'disputeAmount',
            },
            {
              description: 'Card Type',
              name: 'Card Type',
              displayType: 'cardType',
              columnKey: 'cardBrandCode',
            },
            {
              description: 'Reason Code',
              name: 'Reason Code',
              displayType: 'RC',
              columnKey: 'disputeReasonCode',
              descriptionKey: 'codeDescription',
            },
            {
              description: 'Due Date',
              name: 'Due Date',
              displayType: 'DUEDATE',
              columnKey: 'dueDate',
            },
          ],
        },
        summaryPanel: {
          summaryColumns: [
            {
              name: 'Case Number',
              displayType: 'STRING',
              columnKey: 'caseNumber',
              displayOrder: 0,
              defaultIsVisible: true,
            },
            {
              name: 'Merchant Number',
              displayType: 'STRING',
              columnKey: 'merchantNumber',
              displayOrder: 1,
              defaultIsVisible: true,
            },
            {
              name: 'Due Date',
              displayType: 'DUEDATE',
              columnKey: 'dueDate',
              displayOrder: 2,
              defaultIsVisible: true,
            },
            {
              name: 'ARN',
              displayType: 'STRING',
              columnKey: 'acqReferenceNumber',
              displayOrder: 3,
              defaultIsVisible: true,
            },
            {
              name: 'Account Number',
              displayType: 'ACCOUNTNUMBER',
              columnKey: 'maskedCardNumber',
              secondaryColumnKey: 'globalToken',
              displayOrder: 4,
              defaultIsVisible: true,
            },
            {
              name: 'Dispute Amount',
              displayType: 'CURRENCY',
              columnKey: 'disputeAmount',
              displayOrder: 5,
              defaultIsVisible: true,
            },
            {
              name: 'Transaction Date',
              displayType: 'DATE',
              columnKey: 'transactionDate',
              displayOrder: 6,
              defaultIsVisible: true,
            },
            {
              name: 'Transaction Reference Number',
              displayType: 'STRING',
              columnKey: 'originalTransactionReferenceNumber',
              displayOrder: 7,
              defaultIsVisible: true,
            },
            {
              name: 'Auth Code',
              displayType: 'STRING',
              columnKey: 'authorizationCode',
              displayOrder: 8,
              defaultIsVisible: true,
            },
            {
              name: 'Reason Code',
              displayType: 'RC',
              columnKey: 'disputeReasonCode',
              displayOrder: 9,
              defaultIsVisible: true,
              descriptionKey: 'codeDescription',
            },
            {
              name: 'Case Type',
              displayType: 'STRING',
              columnKey: 'disputeStageName',
              displayOrder: 10,
              defaultIsVisible: true,
            },
            {
              name: 'Method of Payment',
              displayType: 'STRING',
              columnKey: 'cardBrandName',
              displayOrder: 11,
              defaultIsVisible: true,
            },
            {
              name: 'Issuer BIN ICA',
              displayType: 'STRING',
              columnKey: 'issuerBinIca',
              displayOrder: 12,
              defaultIsVisible: true,
            },
            {
              name: 'Retrival Response Due Date',
              displayType: 'STRING',
              columnKey: 'retreivalResponseDueDate',
              displayOrder: 13,
              defaultIsVisible: true,
            },
            {
              name: 'Case Received  Date',
              displayType: 'STRING',
              columnKey: 'caseReceivedDate',
              displayOrder: 14,
              defaultIsVisible: true,
            },
            {
              name: 'Support Document Indicator',
              displayType: 'INDICATOR',
              columnKey: 'supportDocumentInd',
              displayOrder: 15,
              defaultIsVisible: true,
            },
            {
              name: 'POS Entry Code',
              displayType: 'STRING',
              columnKey: 'posEntryMode',
              displayOrder: 16,
              defaultIsVisible: true,
            },
            {
              name: 'Member Message Text',
              displayType: 'STRING',
              columnKey: 'memberMessageText',
              displayOrder: 17,
              defaultIsVisible: true,
            },
            {
              name: 'Issuer Reference Number',
              displayType: 'STRING',
              columnKey: 'issuerReferenceNumber',
              displayOrder: 18,
              defaultIsVisible: true,
            },
            {
              name: 'Scheme Case Number',
              displayType: 'STRING',
              columnKey: 'cardBrandCaseNumber',
              displayOrder: 19,
              defaultIsVisible: true,
            },
            {
              name: 'Acquirer BIN ICA',
              displayType: 'STRING',
              columnKey: 'acquirerBinIca',
              displayOrder: 20,
              defaultIsVisible: true,
            },
            {
              name: 'Merchant Name',
              displayType: 'STRING',
              columnKey: 'merchantName',
              displayOrder: 21,
              defaultIsVisible: true,
            },
            {
              name: 'Discover Network Reference ID',
              displayType: 'STRING',
              columnKey: 'networkReferenceId',
              displayOrder: 22,
              defaultIsVisible: true,
            },
            {
              name: 'Discover Case Number',
              displayType: 'STRING',
              columnKey: 'discoverCaseNumber',
              displayOrder: 23,
              defaultIsVisible: true,
            },
            {
              name: 'MC Transaction Lifecycle ID',
              displayType: 'STRING',
              columnKey: 'mcTransactionLifecycleId',
              displayOrder: 24,
              defaultIsVisible: true,
            },
            {
              name: 'MC Assigned ID',
              displayType: 'STRING',
              columnKey: 'mcAssignedId',
              displayOrder: 25,
              defaultIsVisible: true,
            },
            {
              name: 'MC Card Issuer Reference Data',
              displayType: 'STRING',
              columnKey: 'mcCardIssuerReferenceData',
              displayOrder: 26,
              defaultIsVisible: true,
            },
          ],
        },
        searchFilterPanel: {},
        searchFilters:
          [
            {
              defaultValue: null,
              description: 'ARN',
              displayOrder: 1,
              filterValueGroupId: 0,
              isReadOnly: false,
              isVisible: true,
              name: 'ARN',
              reportFilterId: 'acqRefNumber',
              filterType: 'STRING',
              filterValues: null,
              isPrimaryDateFilter: null,
              isRequired: false,
              validations: [],
              columnKey: 'acquirerReferenceNumber',
            },
            {
              defaultValue: null,
              description: 'Card Number',
              displayOrder: 1,
              filterValueGroupId: 0,
              isReadOnly: false,
              isVisible: true,
              name: 'Card Number',
              reportFilterId: 'cardNumberRk',
              filterType: 'STRING',
              filterValues: null,
              isPrimaryDateFilter: null,
              isRequired: false,
              validations: [],
              columnKey: 'maskedCardNumber',
            },
            {
              defaultValue: null,
              description: 'Global Token',
              displayOrder: 1,
              filterValueGroupId: 0,
              isReadOnly: false,
              isVisible: false,
              name: 'Global Token',
              reportFilterId: 'cardNumber',
              filterType: 'STRING',
              filterValues: null,
              isPrimaryDateFilter: null,
              isRequired: false,
              validations: [],
              columnKey: 'globalToken',

            },
            {
              defaultValue: null,
              description: 'Merchant Number',
              displayOrder: 1,
              filterValueGroupId: 0,
              isReadOnly: false,
              isVisible: true,
              name: 'Merchant Number',
              reportFilterId: 'merchant_number',
              filterType: 'STRING',
              filterValues: null,
              isPrimaryDateFilter: null,
              isRequired: false,
              validations: [],
              columnKey: 'merchantNumber',

            },
            {
              defaultValue: null,
              description: 'Transaction Amount',
              displayOrder: 1,
              filterValueGroupId: 0,
              isReadOnly: false,
              isVisible: true,
              name: 'Transaction Amount',
              reportFilterId: 'transactionAmount',
              filterType: 'STRING',
              filterValues: null,
              isPrimaryDateFilter: null,
              isRequired: false,
              validations: [],
              columnKey: 'disputeAmount',

            },
            {
              defaultValue: null,
              description: 'Transaction Date',
              displayOrder: 1,
              filterValueGroupId: 0,
              isReadOnly: false,
              isVisible: true,
              name: 'Transaction Date',
              reportFilterId: 'transactionDate',
              filterType: 'SINGLE_DATE',
              filterValues: null,
              isPrimaryDateFilter: null,
              isRequired: false,
              validations: [],
              columnKey: 'transactionDate',
            },
            {
              defaultValue: null,
              description: 'Transaction Code',
              displayOrder: 1,
              filterValueGroupId: 0,
              isReadOnly: false,
              isVisible: true,
              name: 'Transaction Code',
              reportFilterId: 'transactionCode',
              filterType: 'STRING',
              filterValues: null,
              isPrimaryDateFilter: null,
              isRequired: false,
              validations: [],
              columnKey: 'transactionCode',
            },
          ],
        suggestedPanel: [],
        customComponents: [],
      },
      actions: [
        {
          title: 'View More Details',
          key: 'DETAIL_DRAWER',
          url: 'detail',
          style: {
            paddingLeft: 0,
            width: 150,
          },
        },
        {
          title: 'Open Case',
          url: 'landing',
          key: 'OPEN_CASE',
          style: {
            paddingRight: 60,
            paddingLeft: 0,
            width: 150,
          },
        },
      ],
    },
    {
      queueId: '9',
      pageId: 'unmatch_scheme_image',
      isSummaryRow: false,
      isManualTransaction: false,
      isSummaryPanel: false,
      isHorizontalPanel: false,
      isFilterPane: false,
      isToggle: false,
      isExportable: true,
      canManageColumns: true,
      name: 'Un-Matched Scheme Images',
      detailViewTitle: 'Unmatched Scheme Image',
      returnToText: 'Return to Queue',
      actions: [],
      defaultSort: [{
        key: DOCUMENTRECEIVEDDATE,
        order: 1,
      }],
      imageSelectionConfig: {
        searchFilters:
          [
            {
              defaultValue: null,
              description: 'ARN',
              displayOrder: 1,
              filterValueGroupId: 0,
              isReadOnly: false,
              isVisible: true,
              name: 'ARN',
              reportFilterId: 'acqRefNumber',
              filterType: 'STRING',
              filterValues: null,
              isPrimaryDateFilter: null,
              isRequired: false,
              validations: [],
              columnKey: 'acquirerReferenceNumber',
            },
            {
              defaultValue: null,
              description: 'Card Brand Case Number',
              displayOrder: 1,
              filterValueGroupId: 0,
              isReadOnly: false,
              isVisible: true,
              name: 'Card Brand Case Number',
              reportFilterId: 'cardBrandCaseNumber',
              filterType: 'STRING',
              filterValues: null,
              isPrimaryDateFilter: null,
              isRequired: false,
              validations: [],
              columnKey: 'cardBrandCaseNumber',
            },
            {
              defaultValue: null,
              description: 'Merchant Number',
              displayOrder: 1,
              filterValueGroupId: 0,
              isReadOnly: false,
              isVisible: true,
              name: 'Merchant Number',
              reportFilterId: 'merchant_number',
              filterType: 'STRING',
              filterValues: null,
              isPrimaryDateFilter: null,
              isRequired: false,
              validations: [],
              columnKey: 'merchantNumber',

            },
            {
              defaultValue: null,
              description: 'Transaction Amount',
              displayOrder: 1,
              filterValueGroupId: 0,
              isReadOnly: false,
              isVisible: true,
              name: 'Transaction Amount',
              reportFilterId: 'transactionAmount',
              filterType: 'STRING',
              filterValues: null,
              isPrimaryDateFilter: null,
              isRequired: false,
              validations: [],
              columnKey: 'disputeAmount',

            },
            {
              defaultValue: null,
              description: 'Transaction Date',
              displayOrder: 1,
              filterValueGroupId: 0,
              isReadOnly: false,
              isVisible: true,
              name: 'Transaction Date',
              reportFilterId: 'transactionDate',
              filterType: 'DATE',
              filterValues: null,
              isPrimaryDateFilter: null,
              isRequired: false,
              validations: [],
              columnKey: 'transactionDate',
            },
            {
              defaultValue: null,
              description: 'Transaction Code',
              displayOrder: 1,
              filterValueGroupId: 0,
              isReadOnly: false,
              isVisible: true,
              name: 'Transaction Code',
              reportFilterId: 'transactionCode',
              filterType: 'STRING',
              filterValues: null,
              isPrimaryDateFilter: null,
              isRequired: false,
              validations: [],
              columnKey: 'transactionCode',
            },
            {
              defaultValue: null,
              description: 'Card Number',
              displayOrder: 1,
              filterValueGroupId: 0,
              isReadOnly: false,
              isVisible: true,
              name: 'Card Number',
              reportFilterId: 'cardNumberRk',
              filterType: 'CC_NUMBER',
              filterValues: null,
              isPrimaryDateFilter: null,
              isRequired: false,
              validations: [],
              columnKey: 'maskedCardNumber',
            },
            {
              defaultValue: null,
              description: 'Account Number',
              displayOrder: 1,
              filterValueGroupId: 0,
              isReadOnly: false,
              isVisible: true,
              name: 'Account Number',
              reportFilterId: 'accountNumber',
              filterType: 'STRING',
              filterValues: null,
              isPrimaryDateFilter: null,
              isRequired: false,
              validations: [],
              columnKey: 'accountNumber',
            },
          ],
      },
      dataColumns: [],
      caseSelectionConfig: {
        dateFormat: 'MM/DD/YYYY',
        searchFilters:
          [
            {
              defaultValue: null,
              description: 'ARN',
              displayOrder: 1,
              filterValueGroupId: 0,
              isReadOnly: false,
              isVisible: true,
              name: 'ARN',
              reportFilterId: 'acqRefNumber',
              filterType: 'STRING',
              filterValues: null,
              isPrimaryDateFilter: null,
              isRequired: false,
              validations: [],
              columnKey: 'acquirerReferenceNumber',
            },
            {
              defaultValue: null,
              description: 'Card Number',
              displayOrder: 1,
              filterValueGroupId: 0,
              isReadOnly: false,
              isVisible: true,
              name: 'Card Number',
              reportFilterId: 'cardNumberRk',
              filterType: 'STRING',
              filterValues: null,
              isPrimaryDateFilter: null,
              isRequired: false,
              validations: [],
              columnKey: 'maskedCardNumber',
            },
            {
              defaultValue: null,
              description: 'Global Token',
              displayOrder: 1,
              filterValueGroupId: 0,
              isReadOnly: false,
              isVisible: false,
              name: 'Global Token',
              reportFilterId: 'cardNumber',
              filterType: 'STRING',
              filterValues: null,
              isPrimaryDateFilter: null,
              isRequired: false,
              validations: [],
              columnKey: 'globalToken',

            },
            {
              defaultValue: null,
              description: 'Merchant Number',
              displayOrder: 1,
              filterValueGroupId: 0,
              isReadOnly: false,
              isVisible: true,
              name: 'Merchant Number',
              reportFilterId: 'merchant_number',
              filterType: 'STRING',
              filterValues: null,
              isPrimaryDateFilter: null,
              isRequired: false,
              validations: [],
              columnKey: 'merchantNumber',

            },
            {
              defaultValue: null,
              description: 'Transaction Amount',
              displayOrder: 1,
              filterValueGroupId: 0,
              isReadOnly: false,
              isVisible: true,
              name: 'Transaction Amount',
              reportFilterId: 'transactionAmount',
              filterType: 'STRING',
              filterValues: null,
              isPrimaryDateFilter: null,
              isRequired: false,
              validations: [],
              columnKey: 'disputeAmount',

            },
            {
              defaultValue: null,
              description: 'Transaction Date',
              displayOrder: 1,
              filterValueGroupId: 0,
              isReadOnly: false,
              isVisible: true,
              name: 'Transaction Date',
              reportFilterId: 'transactionDate',
              filterType: 'SINGLE_DATE',
              filterValues: null,
              isPrimaryDateFilter: null,
              isRequired: false,
              validations: [],
              columnKey: 'transactionDate',
            },
            {
              defaultValue: null,
              description: 'Transaction Code',
              displayOrder: 1,
              filterValueGroupId: 0,
              isReadOnly: false,
              isVisible: true,
              name: 'Transaction Code',
              reportFilterId: 'transactionCode',
              filterType: 'STRING',
              filterValues: null,
              isPrimaryDateFilter: null,
              isRequired: false,
              validations: [],
              columnKey: 'transactionCode',
            },
          ],

        imageSearchDataPanel: {
          summaryColumns: [
            {
              name: 'Card Brand Case Number',
              displayType: 'STRING',
              columnKey: 'cardBrandCaseNumber',
              displayOrder: 1,
              defaultIsVisible: true,
            },
            {
              name: 'Transaction ID',
              displayType: 'STRING',
              columnKey: 'transactionId',
              displayOrder: 2,
              defaultIsVisible: true,
            },
            {
              name: 'ARN',
              displayType: 'STRING',
              columnKey: 'arn',
              displayOrder: 3,
              defaultIsVisible: true,
            },
            {
              name: 'Transaction Reference ID',
              displayType: 'STRING',
              columnKey: 'transactionReferenceId',
              displayOrder: 4,
              defaultIsVisible: true,
            },
            {
              name: 'Retreival Reference',
              displayType: 'STRING',
              columnKey: 'retreivalReference',
              displayOrder: 5,
              defaultIsVisible: true,
            },
            {
              name: 'Transaction Amount',
              displayType: 'STRING',
              columnKey: 'transactionAmount',
              displayOrder: 6,
              defaultIsVisible: true,
            },


          ],
          summaryContent: {
            caseNumber: '--',
            transactionId: '124578966325478',
            arn: '1200983746653427765432',
            transactionReferenceId: '12457896312545478',
            retreivalReference: '48448xxxxxx7236',
            transactionAmount: '320.00',

          },
        },
        imageSearchResultsPanel: {

          assignColumns: [
            {
              name: 'Attach - All Pages',
              displayType: 'BUTTON',
              columnKey: '',
              displayOrder: 0,
              defaultIsVisible: true,
              isCustomRow: true,
            },
            {
              name: 'Case Number',
              displayType: 'summary',
            },
            {
              name: 'Pages',
              displayType: 'summary',
              
            },
            {
              name: 'Assign Label',
              displayType: 'summary',
              
            },
            {
              name: 'Clear Pages',
              displayType: 'summary',
              
            },
          ],
          summaryColumns: [
            {
              name: 'Case Number',
              displayType: 'STRING',
              columnKey: 'caseDetail_caseNumber',
              displayOrder: 0,
              defaultIsVisible: true,
              isCustomRow: true,
            },
            {
              name: 'Days Left - Status',
              displayType: 'STATUS',
              columnKey: 'caseStageDetail_statusId',
              secondaryColumnKey: 'daysToAct',
              displayOrder: 1,
              defaultIsVisible: true,
              isCustomRow: true,
            },

            {
              name: 'Stage',
              displayType: 'STRING',
              columnKey: 'caseStageDetail_disputeStageName',
              displayOrder: 2,
              defaultIsVisible: true,
              isCustomRow: true,
            },
           

            {
             
              isBorderClass:true,
              defaultIsVisible: true,
              
            },

            {
              name: 'Card Number',
              displayType: 'ACCOUNTNUMBER',
              columnKey: 'caseDetail_maskedCardNumber',
              secondaryColumnKey: 'caseDetail_globalToken',
              cardLogoKey:'caseDetail_cardBrandCode',
              displayOrder: 4,
              defaultIsVisible: true,
              isCustomRow: true,
            },
            {
              name: 'Transaction Details',
              displayType: 'DATE',
              columnKey: 'caseDetail_transactionDate',
              secondaryColumnKey: 'caseDetail_transactionAmount',
              displayOrder: 5,
              defaultIsVisible: true,
              isCustomRow: true,
            },
            
            {
              name: 'Approval Code',
              displayType: 'STRING',
              columnKey: 'caseDetail_authorizationCode',
              displayOrder: 6,
              defaultIsVisible: true,
              isCustomRow: true,
            },
            {
               defaultIsVisible: true,
               isBorderClass:true,
             },
          
            {
              name: 'Latest Disposition',
              displayType: 'DISP',
              columnKey: 'latestDisposition',
              displayOrder: 7,
              defaultIsVisible: true,
              isCustomRow: true,
            },
            {             
               defaultIsVisible: false,
               isBorderClass:true,
             },
            {
              name: 'Merchant Name',
              displayType: 'STRING',
              columnKey: 'caseDetail_merchantName',
              displayOrder: 8,
              defaultIsVisible: false,
              isCustomRow:true,
            },
            {
              name: 'Merchant Number',
              displayType: 'STRING',
              columnKey: 'merchantNumber',
              displayOrder: 9,
              defaultIsVisible: false,
              isCustomRow: true,
            },
           
            {
              name: 'ARN',
              displayType: 'STRING',
              columnKey: 'caseDetail_acqReferenceNumber',
              displayOrder: 10,
              defaultIsVisible: false,
              isCustomRow: true,
            },
            {
              defaultIsVisible: false,
              isBorderClass:true,
             },
            {
              name: 'Reason Code',
              displayType: 'RC',
              columnKey: 'caseStageDetail_disputeReasonCode',
              displayOrder: 11,
              defaultIsVisible: false,
              descriptionKey: 'caseStageDetail_codeDescription',
              isCustomRow: true,
            },
            {
              name: 'POS Entry Mode',
              displayType: 'STRING',
              columnKey: 'posEntryMode',
              displayOrder: 12,
              defaultIsVisible: false,
              isCustomRow: true,
            },
            {
              name: 'Zone',
              displayType: 'STRING',
              columnKey: 'caseDetail_merchantRegionCode',
              displayOrder: 13,
              defaultIsVisible: false,
              isCustomRow: true,
            },
            {
               defaultIsVisible: false,
               isBorderClass:true,
             },
            
          ],
          summaryContent: [{
            caseNumber: '6657380988',
            transactionAmount: '320.00',
            transactionDate: '02-25-2019',
            cardNumber: '47448xxxxxx7236',
            approvalCode: '667098',
            arn: '12009837466534277654320',
            merchantNumber: '004',
            merchantName: 'test',
            reasonCode: '01',
            posEntryMode: 'test1',
          },
          {
            caseNumber: '7657380988',
            transactionAmount: '320.00',
            transactionDate: '02-25-2019',
            cardNumber: '47448xxxxxx7236',
            approvalCode: '667098',
            arn: '12009837466534277654320',
            merchantNumber: '004',
            merchantName: 'test',
            reasonCode: '01',
            posEntryMode: 'test2',
          },

          {
            caseNumber: '8657380988',
            transactionAmount: '320.00',
            transactionDate: '02-25-2019',
            cardNumber: '47448xxxxxx7236',
            approvalCode: '667098',
            arn: '12009837466534277654320',
            merchantNumber: '004',
            merchantName: 'test',
            reasonCode: '01',
            posEntryMode: 'test4',
          },

          ],

        },


      },
    },
    {
      queueId: '15',
      pageId: 'unmatch_merch_image',
      isSummaryRow: false,
      isManualTransaction: false,
      isSummaryPanel: false,
      isHorizontalPanel: false,
      isFilterPane: false,
      isToggle: false,
      dataColumns: [],
      isExportable: true,
      canManageColumns: true,
      name: 'Un-Matched Merchant Images',
      detailViewTitle: 'Unmatched Merchant Image',
      defaultSort: [{
        key: DOCUMENTRECEIVEDDATE,
        order: 1,
      }],
      returnToText: 'Return to Queue',
      actions: [],
      imageSelectionConfig: {
        searchFilters:
          [
            {
              defaultValue: null,
              description: 'ARN',
              displayOrder: 1,
              filterValueGroupId: 0,
              isReadOnly: false,
              isVisible: true,
              name: 'ARN',
              reportFilterId: 'acqRefNumber',
              filterType: 'STRING',
              filterValues: null,
              isPrimaryDateFilter: null,
              isRequired: false,
              validations: [],
              columnKey: 'acquirerReferenceNumber',
            },
            {
              defaultValue: null,
              description: 'Case Number',
              displayOrder: 1,
              filterValueGroupId: 0,
              isReadOnly: false,
              isVisible: true,
              name: 'Case Number',
              reportFilterId: 'caseNumber',
              filterType: 'STRING',
              filterValues: null,
              isPrimaryDateFilter: null,
              isRequired: false,
              validations: [],
              columnKey: 'caseNumber',
            },
            {
              defaultValue: null,
              description: 'Merchant Number',
              displayOrder: 1,
              filterValueGroupId: 0,
              isReadOnly: false,
              isVisible: true,
              name: 'Merchant Number',
              reportFilterId: 'merchant_number',
              filterType: 'STRING',
              filterValues: null,
              isPrimaryDateFilter: null,
              isRequired: false,
              validations: [],
              columnKey: 'merchantNumber',

            },
            {
              defaultValue: null,
              description: 'Transaction Amount',
              displayOrder: 1,
              filterValueGroupId: 0,
              isReadOnly: false,
              isVisible: true,
              name: 'Transaction Amount',
              reportFilterId: 'transactionAmount',
              filterType: 'STRING',
              filterValues: null,
              isPrimaryDateFilter: null,
              isRequired: false,
              validations: [],
              columnKey: 'disputeAmount',

            },
            {
              defaultValue: null,
              description: 'Transaction Date',
              displayOrder: 1,
              filterValueGroupId: 0,
              isReadOnly: false,
              isVisible: true,
              name: 'Transaction Date',
              reportFilterId: 'transactionDate',
              filterType: 'DATE',
              filterValues: null,
              isPrimaryDateFilter: null,
              isRequired: false,
              validations: [],
              columnKey: 'transactionDate',
            },
            {
              defaultValue: null,
              description: 'Transaction Code',
              displayOrder: 1,
              filterValueGroupId: 0,
              isReadOnly: false,
              isVisible: true,
              name: 'Transaction Code',
              reportFilterId: 'transactionCode',
              filterType: 'STRING',
              filterValues: null,
              isPrimaryDateFilter: null,
              isRequired: false,
              validations: [],
              columnKey: 'transactionCode',
            },
            {
              defaultValue: null,
              description: 'Card Number',
              displayOrder: 1,
              filterValueGroupId: 0,
              isReadOnly: false,
              isVisible: true,
              name: 'Card Number',
              reportFilterId: 'cardNumberRk',
              filterType: 'CC_NUMBER',
              filterValues: null,
              isPrimaryDateFilter: null,
              isRequired: false,
              validations: [],
              columnKey: 'maskedCardNumber',
            },
            {
              defaultValue: null,
              description: 'Account Number',
              displayOrder: 1,
              filterValueGroupId: 0,
              isReadOnly: false,
              isVisible: true,
              name: 'Account Number',
              reportFilterId: 'accountNumber',
              filterType: 'STRING',
              filterValues: null,
              isPrimaryDateFilter: null,
              isRequired: false,
              validations: [],
              columnKey: 'accountNumber',
            },
          ],
      },
      caseSelectionConfig: {
        dateFormat: 'MM/DD/YYYY',
        searchFilters:
          [
            {
              defaultValue: null,
              description: 'ARN',
              displayOrder: 1,
              filterValueGroupId: 0,
              isReadOnly: false,
              isVisible: true,
              name: 'ARN',
              reportFilterId: 'acqRefNumber',
              filterType: 'STRING',
              filterValues: null,
              isPrimaryDateFilter: null,
              isRequired: false,
              validations: [],
              columnKey: 'acquirerReferenceNumber',
            },
            {
              defaultValue: null,
              description: 'Card Number',
              displayOrder: 1,
              filterValueGroupId: 0,
              isReadOnly: false,
              isVisible: true,
              name: 'Card Number',
              reportFilterId: 'cardNumberRk',
              filterType: 'STRING',
              filterValues: null,
              isPrimaryDateFilter: null,
              isRequired: false,
              validations: [],
              columnKey: 'maskedCardNumber',
            },
            {
              defaultValue: null,
              description: 'Global Token',
              displayOrder: 1,
              filterValueGroupId: 0,
              isReadOnly: false,
              isVisible: false,
              name: 'Global Token',
              reportFilterId: 'cardNumber',
              filterType: 'STRING',
              filterValues: null,
              isPrimaryDateFilter: null,
              isRequired: false,
              validations: [],
              columnKey: 'globalToken',

            },
            {
              defaultValue: null,
              description: 'Merchant Number',
              displayOrder: 1,
              filterValueGroupId: 0,
              isReadOnly: false,
              isVisible: true,
              name: 'Merchant Number',
              reportFilterId: 'merchant_number',
              filterType: 'STRING',
              filterValues: null,
              isPrimaryDateFilter: null,
              isRequired: false,
              validations: [],
              columnKey: 'merchantNumber',

            },
            {
              defaultValue: null,
              description: 'Transaction Amount',
              displayOrder: 1,
              filterValueGroupId: 0,
              isReadOnly: false,
              isVisible: true,
              name: 'Transaction Amount',
              reportFilterId: 'transactionAmount',
              filterType: 'STRING',
              filterValues: null,
              isPrimaryDateFilter: null,
              isRequired: false,
              validations: [],
              columnKey: 'disputeAmount',

            },
            {
              defaultValue: null,
              description: 'Transaction Date',
              displayOrder: 1,
              filterValueGroupId: 0,
              isReadOnly: false,
              isVisible: true,
              name: 'Transaction Date',
              reportFilterId: 'transactionDate',
              filterType: 'SINGLE_DATE',
              filterValues: null,
              isPrimaryDateFilter: null,
              isRequired: false,
              validations: [],
              columnKey: 'transactionDate',
            },
            {
              defaultValue: null,
              description: 'Transaction Code',
              displayOrder: 1,
              filterValueGroupId: 0,
              isReadOnly: false,
              isVisible: true,
              name: 'Transaction Code',
              reportFilterId: 'transactionCode',
              filterType: 'STRING',
              filterValues: null,
              isPrimaryDateFilter: null,
              isRequired: false,
              validations: [],
              columnKey: 'transactionCode',
            },
          ],
        imageSearchDataPanel: {
          summaryColumns: [
            {
              name: 'Case Number',
              displayType: 'STRING',
              columnKey: 'caseNumber',
              displayOrder: 1,
              defaultIsVisible: true,
            },
            {
              name: 'Transaction ID',
              displayType: 'STRING',
              columnKey: 'transactionId',
              displayOrder: 2,
              defaultIsVisible: true,
            },
            {
              name: 'ARN',
              displayType: 'STRING',
              columnKey: 'arn',
              displayOrder: 3,
              defaultIsVisible: true,
            },
            {
              name: 'Transaction Reference ID',
              displayType: 'STRING',
              columnKey: 'transactionReferenceId',
              displayOrder: 4,
              defaultIsVisible: true,
            },
            {
              name: 'Retreival Reference',
              displayType: 'STRING',
              columnKey: 'retreivalReference',
              displayOrder: 5,
              defaultIsVisible: true,
            },
            {
              name: 'Transaction Amount',
              displayType: 'STRING',
              columnKey: 'transactionAmount',
              displayOrder: 6,
              defaultIsVisible: true,
            },


          ],
          summaryContent: {
            caseNumber: '--',
            transactionId: '124578966325478',
            arn: '1200983746653427765432',
            transactionReferenceId: '12457896312545478',
            retreivalReference: '48448xxxxxx7236',
            transactionAmount: '320.00',

          },
        },
        imageSearchResultsPanel: {

          assignColumns: [
            {
              name: 'Attach - All Pages',
              displayType: 'BUTTON',
              columnKey: '',
              displayOrder: 0,
              defaultIsVisible: true,
              isCustomRow: true,
            },
            {
              name: 'Case Number',
              displayType: 'summary',
            },
            {
              name: 'Pages',
              displayType: 'summary',
              
            },
            {
              name: 'Assign Label',
              displayType: 'summary',
              
            },
            {
              name: 'Clear Pages',
              displayType: 'summary',
              
            },
          ],

          summaryColumns: [
            {
              name: 'Case Number',
              displayType: 'STRING',
              columnKey: 'caseDetail_caseNumber',
              displayOrder: 0,
              defaultIsVisible: true,
              isCustomRow: true,
            },
            {
              name: 'Days Left - Status',
              displayType: 'STATUS',
              columnKey: 'caseStageDetail_statusId',
              secondaryColumnKey: 'daysToAct',
              displayOrder: 1,
              defaultIsVisible: true,
              isCustomRow: true,
            },

            {
              name: 'Stage',
              displayType: 'STRING',
              columnKey: 'caseStageDetail_disputeStageName',
              displayOrder: 2,
              defaultIsVisible: true,
              isCustomRow: true,
            },

            {
              defaultIsVisible: true,
              isBorderClass:true,
            },

            {
              name: 'Card Number',
              displayType: 'ACCOUNTNUMBER',
              columnKey: 'caseDetail_maskedCardNumber',
              secondaryColumnKey: 'caseDetail_globalToken',
              cardLogoKey:'caseDetail_cardBrandCode',
              displayOrder: 4,
              defaultIsVisible: true,
              isCustomRow: true,
            },
            {
              name: 'Transaction Details',
              displayType: 'DATE',
              columnKey: 'caseDetail_transactionDate',
              secondaryColumnKey: 'caseDetail_transactionAmount',
              displayOrder: 5,
              defaultIsVisible: true,
              isCustomRow: true,
            },
            
            {
              name: 'Approval Code',
              displayType: 'STRING',
              columnKey: 'caseDetail_authorizationCode',
              displayOrder: 6,
              defaultIsVisible: true,
              isCustomRow: true,
            },
            {
               defaultIsVisible: true,
               isBorderClass:true,
             },
          
            {
              name: 'Latest Disposition',
              displayType: 'DISP',
              columnKey: 'latestDisposition',
              displayOrder: 7,
              defaultIsVisible: true,
              isCustomRow: true,
            },
            {             
               defaultIsVisible: false,
               isBorderClass:true,
             },
            {
              name: 'Merchant Name',
              displayType: 'STRING',
              columnKey: 'caseDetail_merchantName',
              displayOrder: 8,
              defaultIsVisible: false,
              isCustomRow:true,
            },
            {
              name: 'Merchant Number',
              displayType: 'STRING',
              columnKey: 'merchantNumber',
              displayOrder: 9,
              defaultIsVisible: false,
              isCustomRow: true,
            },
           
            {
              name: 'ARN',
              displayType: 'STRING',
              columnKey: 'caseDetail_acqReferenceNumber',
              displayOrder: 10,
              defaultIsVisible: false,
              isCustomRow: true,
            },
            {
              defaultIsVisible: false,
              isBorderClass:true,
             },
            {
              name: 'Reason Code',
              displayType: 'RC',
              columnKey: 'caseStageDetail_disputeReasonCode',
              displayOrder: 11,
              defaultIsVisible: false,
              descriptionKey: 'caseStageDetail_codeDescription',
              isCustomRow: true,
            },
            {
              name: 'POS Entry Mode',
              displayType: 'STRING',
              columnKey: 'posEntryMode',
              displayOrder: 12,
              defaultIsVisible: false,
              isCustomRow: true,
            },
            {
              name: 'Zone',
              displayType: 'STRING',
              columnKey: 'caseDetail_merchantRegionCode',
              displayOrder: 13,
              defaultIsVisible: false,
              isCustomRow: true,
            },
            {
               defaultIsVisible: false,
               isBorderClass:true,
             },
            
          ],
          summaryContent: [{
            caseNumber: '6657380988',
            transactionAmount: '320.00',
            transactionDate: '02-25-2019',
            cardNumber: '47448xxxxxx7236',
            approvalCode: '667098',
            arn: '12009837466534277654320',
            merchantNumber: '004',
            merchantName: 'test',
            reasonCode: '01',
            posEntryMode: 'test1',
          },
          {
            caseNumber: '7657380988',
            transactionAmount: '320.00',
            transactionDate: '02-25-2019',
            cardNumber: '47448xxxxxx7236',
            approvalCode: '667098',
            arn: '12009837466534277654320',
            merchantNumber: '004',
            merchantName: 'test',
            reasonCode: '01',
            posEntryMode: 'test2',
          },

          {
            caseNumber: '8657380988',
            transactionAmount: '320.00',
            transactionDate: '02-25-2019',
            cardNumber: '47448xxxxxx7236',
            approvalCode: '667098',
            arn: '12009837466534277654320',
            merchantNumber: '004',
            merchantName: 'test',
            reasonCode: '01',
            posEntryMode: 'test4',
          },

          ],

        },

      },
    },
    {
      queueId: '36',
      pageId: 'case_pend_image',
      isSummaryRow: false,
      isManualTransaction: false,
      isSummaryPanel: false,
      isHorizontalPanel: false,
      isFilterPane: false,
      isToggle: false,
      dataColumns: [],
      isExportable: true,
      canManageColumns: true,
      name: 'Case Pend For Images',
      detailViewTitle: 'Case Details',
      returnToText: 'Return to Queue',
      defaultSort: [{
        key: 'dueDate',
        order: 1,
      },{
        key: 'disputeAmount',
        order: 0,
      }],
      actions: [
        {
          title: 'Open Case',
          key: 'CASE_LANDING',
          style: {
            paddingRight: 60,
            paddingLeft: 0,
            width: 150,
          },

        },
      ],
    },
    {
      queueId: '80',
      pageId: 'wex_queue',
      //dataColumns: [],
     // isExportable: true,
      //canManageColumns: true,
      isFilterPane: true,
      searchFilterName: 'wex_case',
      dataColumns: [],
      isExportable: true,
      canManageColumns: true,
      name: 'Un-Matched Wex ARNs',
      detailViewTitle: 'Case Details',
      returnToText: 'Return to Queue',
      defaultSort: [{
        key: 'dueDate',
        order: 1,
      },{
        key: 'disputeAmount',
        order: 0,
      }],
      actions: [
        {
          title: 'View More Details',
          key: 'DETAIL_DRAWER',
          style: {
            width: 150,
            paddingLeft: 0,
          },

        },
        {
          title: 'Open Case',
          key: 'CASE_LANDING',
          style: {
            paddingRight: 60,
            paddingLeft: 0,
            width: 150,
          },

        },

      ],
    },
    {
      queueId: '81',
      pageId: 'active_stage',
      dataColumns: [],
      isExportable: true,
      canManageColumns: true,
      isFilterPane: true,
      searchFilterName: 'active_stage',
      dataColumns: [],
      isExportable: true,
      canManageColumns: true,
      name: 'Active Stage',
      detailViewTitle: 'Case Details',
      returnToText: 'Return to Queue',
      defaultSort: [{
        key: 'dueDate',
        order: 1,
      },{
        key: 'disputeAmount',
        order: 0,
      }],
      actions: [
        {
          title: 'View More Details',
          key: 'DETAIL_DRAWER',
          style: {
            width: 150,
            paddingLeft: 0,
          },

        },
        {
          title: 'Open Case',
          key: 'CASE_LANDING',
          style: {
            paddingRight: 60,
            paddingLeft: 0,
            width: 150,
          },

        },

      ],
    },
    {
      queueId: '71',
      pageId: 'amex_queue',
      dataColumns: [],
      isExportable: true,
      canManageColumns: true,
      isFilterPane: true,
      searchFilterName: 'amex_case',
      dataColumns: [],
      isExportable: true,
      canManageColumns: true,
      name: 'Amex Optblue Op1 Cases & Amex One Point Cases',
      detailViewTitle: 'Case Details',
      returnToText: 'Return to Queue',
      defaultSort: [{
        key: 'dueDate',
        order: 1,
      },{
        key: 'disputeAmount',
        order: 0,
      }],
      actions: [
        {
          title: 'View More Details',
          key: 'DETAIL_DRAWER',
          style: {
            width: 150,
            paddingLeft: 0,
          },

        },
        {
          title: 'Open Case',
          key: 'CASE_LANDING',
          style: {
            paddingRight: 60,
            paddingLeft: 0,
            width: 150,
          },

        },

      ],
    },
  ].find((queueMetaData) => {
    return queueMetaData.queueId == queueId;
  });
}


export function getTranslations() {
  return {
    applyFilterPane: 'Search',
    cancel: 'Cancel',
    clearFilterPane: 'Clear All Fields',
    less: 'Less',
    more: 'More',
    save: 'Save',
    select: 'Select',
    dates: {
      apply: 'Apply',
      cancel: 'Cancel',
      custom: 'Custom',
      fri: 'Fri',
      from: 'From',
      lastMonth: 'Last Month',
      lastSevenDays: 'Last 7 Days',
      lastThirtyDays: 'Last 30 Days',
      lastWeek: 'Last Week',
      lastYear: 'Select Date(s)',
      mon: 'Mon',
      sat: 'Sat',
      sun: 'Sun',
      thisMonth: 'This Month',
      thisYear: 'This Year',
      thu: 'Thu',
      to: 'To',
      tue: 'Tue',
      unselectedText: 'Select Date(s)',
      validDateError: 'Please enter a valid date.',
      wed: 'Wed',
      yesterday: 'Yesterday',
      jan:'January',
      feb:'February',
      mar:'March',
      apr:'April',
      may:'May',
      jun:'June',
      jul:'July',
      aug:'August',
      sep:'September',
      oct:'October',
      nov:'November',
      dec:'December',
    },
    actions: 'Actions',
    active: 'Active',
    addAll: 'Add All',
    apply: 'Apply',
    applyFilterPane: 'Apply',
    backLinkText: 'Back to Reports',
    cancel: 'Cancel',
    clearAll: 'Clear All',
    clear: 'Reset',
    columns: 'Columns',
    createAFilterContent: 'To select a filter, please create a filter.',
    createAFilterTitle: 'Start by creating a filter',
    currency: 'Currency',
    export: 'Export',
    exporting: 'Exporting',
    exportTypesTitle: 'What do you want to export?',
    fileName: 'Name of file:',
    fileTypesTitle: 'Export As:',
    fileNameLabel: 'Name of File:',
    filterPaneTriggerText: 'Filter',
    filters: 'Filters',
    header: 'Export Data',
    hideAll: 'Hide All',
    inactive: 'Inactive',
    less: 'Less',
    more: 'More',
    next: 'Next',
    prev: 'Prev',
    page: 'Page',
    placeholder: 'Search by Filter Name...',
    preposition: 'of',
    removeAll: 'Remove All',
    save: 'Save',
    savedFilters: 'Saved Filters',
    searchCurrencies: 'Search Currencies',
    shareReport: 'Share Report',
    showAll: 'Show All',
    show25perPage: 'Show 25 per page',
    show50perPage: 'Show 50 per page',
    show75perPage: 'Show 75 per page',
    show100perPage: 'Show 100 per page',
    showingRecords: 'Showing records',
    summaryTitle: 'Summary',
    title: 'Saved Filters',
    saveFilterLabel: 'Filter Name',
    saveFilterTitle: 'Save Filter',
    availableColumns: 'Available Columns',
    searchAvailableColumns: 'Search Available Columns',
    activeColumns: 'Active Columns',
    selected: 'Selected',
    searchActiveColumns: 'Search Active Columns',
    cardNum: 'Account Number (first 6 or last 4 digits)',
    helperText: '(first 6 or last 4 digits)',
    first6Placeholder: counterpart('globalTranslate.queues.firstSix'),
    last4Placeholder: counterpart('globalTranslate.queues.lastFour'),
    searchReasonCodePlaceholder: counterpart('globalTranslate.caseSearch.searchReasonCode'),
  };
}


export function getValidations(elementTypeName) {
  return [
    {
      id: 'DATE',
      validations: [
        {
          validationRuleKey: 'DATE_RANGE_VALIDATION',
          validationRef: '',
          translatedErrorMessage: 'Start Date must be before End Date. Check the dates and try again.',
          sequence: 0,
        },
      ],
    },
  ].find((queueMetaData) => {
    return queueMetaData.id === elementTypeName;
  });
}

export function getBookMarkIconValues() {
  return {
    defaultIsVisible: true,
    description: '',
    isRequired: false,
    isSortable: false,
    isSummaryColumn: false,
    name: '',
    sortDirection: null,
    sortOrderPriority: 0,
    displayType: 'ICON',
    columnKey: 'BookMarkIcon',
    displayOrder: -2,
    isSelected: true,
  }
}

export function getFolderIconValues() {
  return {
    defaultIsVisible: true,
    description: '',
    isRequired: false,
    isSortable: false,
    isSummaryColumn: false,
    name: '',
    sortDirection: null,
    sortOrderPriority: 0,
    displayType: 'ICON',
    columnKey: 'FolderIcon',
    displayOrder: 100,
    isSelected: true,
  }
}

export function getImageIconValues() {
  return {
    defaultIsVisible: true,
    description: '',
    isRequired: false,
    isSortable: false,
    isSummaryColumn: false,
    name: '',
    sortDirection: null,
    sortOrderPriority: 0,
    displayType: 'ICON',
    columnKey: 'imageIcon',
    displayOrder: 4,
    isSelected: true,
  }
}

export function getDeleteIconValues() {
  return {
    defaultIsVisible: true,
    description: '',
    isRequired: false,
    isSortable: false,
    isSummaryColumn: false,
    name: '',
    sortDirection: null,
    sortOrderPriority: 0,
    displayType: 'ICON',
    columnKey: 'trashIcon',
    displayOrder: 5,
    isSelected: true,
  }
}
export function getOpenInNewTabValues() {
  return {
    defaultIsVisible: true,
    description: '',
    isRequired: false,
    isSortable: false,
    isSummaryColumn: false,
    name: '',
    sortDirection: null,
    sortOrderPriority: 0,
    displayType: 'ICON',
    columnKey: 'OpenInNewTabIcon',
    displayOrder: 100,
    isSelected: true,
  }
}
